import { useState, useEffect } from "react";
import { motion } from "framer-motion";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.nav
      data-testid="navbar"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FAF7F3]/85 backdrop-blur-xl border-b border-[#D8D2C6]/40 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex items-center justify-between">
        <button onClick={() => scrollTo("hero")} className="flex items-center">
          <img
            src={scrolled ? "/images/logos/logo-siyah.svg" : "/images/logos/logo-beyaz.svg"}
            alt="FINORA"
            className="h-8 md:h-9 transition-all duration-500"
            data-testid="navbar-logo"
          />
        </button>

        <div className="hidden md:flex items-center gap-10">
          {[
            { label: "HİKAYE", id: "brand-story" },
            { label: "PROJE", id: "project-overview" },
            { label: "KONUM", id: "location" },
            { label: "YATIRIM", id: "investment" },
            { label: "GALERİ", id: "gallery" },
          ].map((item) => (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => scrollTo(item.id)}
              className={`font-sub text-[11px] tracking-[0.18em] font-semibold transition-all duration-300 hover:opacity-100 ${
                scrolled ? "text-[#5A5A58] hover:text-[#c13a05]" : "text-white/70 hover:text-white"
              }`}
            >
              {item.label}
            </button>
          ))}
          <button
            data-testid="nav-contact-btn"
            onClick={() => scrollTo("contact")}
            className={`font-sub text-[11px] tracking-[0.18em] font-bold px-6 py-2.5 transition-all duration-300 ${
              scrolled
                ? "bg-[#c13a05] text-white hover:bg-[#a83004]"
                : "bg-white/15 text-white border border-white/30 hover:bg-white/25 backdrop-blur-sm"
            }`}
          >
            İLETİŞİM
          </button>
        </div>

        <button
          data-testid="mobile-menu-btn"
          onClick={() => scrollTo("contact")}
          className={`md:hidden font-sub text-[11px] tracking-[0.15em] font-bold px-4 py-2 transition-colors ${
            scrolled
              ? "bg-[#c13a05] text-white"
              : "bg-white/15 text-white border border-white/30 backdrop-blur-sm"
          }`}
        >
          İLETİŞİM
        </button>
      </div>
    </motion.nav>
  );
}
